import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

/**
 * Per requirement GP-12, this provides a list of dependencies within a price calculation (MAMP dependencies to QAMP and QAMP and BP dependencies for URA)
 */
export const CalcDepList = ({ calcObj }) => {
  const rsrc = useRsrc();

  const clientSideRowData = useCallback((setDataSource) => {
    const rowsReq = {
      expr: ExprUtils.whereParams('calcId', calcObj.id)
    }
    rsrc.rows('gp', 'CALC_DEPS_UI', rowsReq).then(rows => {
      setDataSource(rows);
    });
  }, [calcObj]);

  const augFieldDefs = (fieldToFieldDef) => {
    // Don't format Source Id as number
    fieldToFieldDef.srcId.type = 'NONE';
  }


  return (
    <EntityList
      entity="CALC_DEP"
      clientSideRowData={clientSideRowData}
      augFieldDefs={augFieldDefs}
      gridOptions={{ getContextMenuItems: {} }}
      augTabButtons={(buttons) => { ObjUtils.clearObj(buttons) }}
    />
  )
}